import { createFileRoute } from '@tanstack/react-router';
import { DocsViewContext } from '../../../../features/docs/docs-context';
import { getPageHead } from '../../../../util/routing/meta';

export const Route = createFileRoute('/docs/_layout/guide/_provider')({
  staticData: {
    docsViewContext: DocsViewContext.Guides,
  },
  head: () => getPageHead('Guides'),
});
